define('application',[
    //lib
    'jquery',
    'flickity',
    
    //module
    'module/flickity',
    'module/tile-wall',
    'module/video',
    'module/form',
    'module/deeplink',
    'module/cookie-consent',
    'module/fade',
    'module/logo-grid',
    'module/menu',
    'module/filter',
    'module/toggle',
    'module/team-wall',
    'module/map',
    'module/share',
    'module/upload-form',
    'module/ugc',
    'module/ugc-photowall',
    'module/lightbox',
    'module/hotspot',
    'module/lazy-loading',
    'module/newsletter-popup',
    
    //pubsub
    'pubsub/resize',
    'pubsub/scroll',
    'pubsub/brightcove',
    'pubsub/vimeo',
    'pubsub/youtube',
    
    //bridget at last
    'jqueryBridget',
    //inc mobile as well, deps on main.js does not work somehow on minified version
    /**
     * @jira FDZ-713: no more need since jquery v3.4
    'jqueryMobile',
     */
    //plugin instagram-feed
    /**
     * @jira FDZ-712, @date 2023-10-19: disabled since plugin v6
    'instagram_feed'
     */
],function(
        //lib
        $,Flickity,
        
        //mod
        ModFlickity, ModTilewall, ModVideo, ModForm, ModDeeplink, ModCookie, ModFade, ModLogoGrid, ModMenu, ModFilter, ModToggle, ModTeam, ModMap, ModShare, ModUploadForm, ModUgc, MogUgcUpload, ModLightbox, ModHotspot, ModLazyLoading, ModNewsletterPopup,
        //pubsub
        PubsubResize,PubsubScroll, PubsubBrightcove, PubsubVimeo, PubsubYT
    ) 
{
    'use strict';
    
    return function(arg)
    {
        this.init=function()
        {
            this.initDebug();
            this.initPubsub();
            this.initVendor();
            this.initModules();
        };
        
        this.initDebug=function()
        {
            /**
             * @jira FDZ-583: disabled so far
            if(false===arg.debug) {
                window.console={
                    log:function(){}
                };
            }
            **/
        };
        
        this.initVendor=function()
        {
            $.bridget('flickity',Flickity);
        };
        
        this.initPubsub=function()
        {
            new PubsubResize;
            new PubsubScroll;
            new PubsubBrightcove;
            new PubsubVimeo;
            new PubsubYT;
        };
        
        this.initModules=function()
        {
            new ModFlickity;
            new ModTilewall;
            new ModVideo;
            new ModForm;
            new ModDeeplink;
            new ModCookie;
            new ModFade;
            new ModLogoGrid;
            new ModMenu;
            new ModFilter;
            new ModToggle;
            new ModTeam;
            new ModMap;
            new ModShare;
            new ModUploadForm;
            new ModUgc;
            new MogUgcUpload;
            new ModLightbox;
            new ModHotspot;
            new ModLazyLoading;
            new ModNewsletterPopup;
        };
        
        this.init();
    };
});
